import ReactDOM from 'react-dom/client';
import App from './components/App';

const el = document.querySelector('.maturity-score');

if (el) {
	const root = ReactDOM.createRoot(el);
	root.render(<App api={el.getAttribute('data-rest-endpoint')} track={el.getAttribute('data-track')} version={el.getAttribute('data-version')} />);
}
